import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES, POOLS } from '@src/constants';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Get exact market addresses from POOLS
    const marketAddresses = POOLS.map(pool => `/${pool.address}`);
    marketAddresses.push(ROUTES.MARKET_ROME);

    // Only scroll if we're exactly on a market route (no nested paths)
    const isExactMarketRoute = marketAddresses.includes(pathname);
    if (isExactMarketRoute) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop; 